var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main-block"},[(_vm.isLogin)?_c('div',{staticClass:"store-block"},[_c('Gift',{attrs:{"isWeb":"","isTypeWeb":'loyaltyCard'}})],1):_vm._e()]),_c('LoginWeb')],1)}
var staticRenderFns = []

export { render, staticRenderFns }